module.exports = __webpack_public_path__ + "img/person-hire3x.eaa396d6.svg";